const config = {
  BASE_API: "https://api.delibuoy.com", 
  // BASE_API: "http://65.2.35.244/",
};
export default config;
